import * as apiUtils from "@/utils/apiUtils"

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    // language: "tw"
    lastlyUsedBusinessId: null
  },
  // -----------------------------------------------------------------
  getters: {
    user: state => () => {
      var user = JSON.parse(localStorage.getItem("user"))
      return user
    },
    uid: state => () => {
      var user = JSON.parse(localStorage.getItem("user"))
      return user.id
    },
    email: state => () => {
      var user = JSON.parse(localStorage.getItem("user"))
      return user.email
    },
    isEmailVerified: state => () => {
      var user = JSON.parse(localStorage.getItem("user"))
      return user.isEmailVerified
    },
    name: state => () => {
      var user = JSON.parse(localStorage.getItem("user"))
      return user.name
    },
    language: state => () => {
      var language = localStorage.getItem("language") || "tw"
      return language
    },
    lastlyUsedBusinessId: state => () => {
      var user = JSON.parse(localStorage.getItem("user"))
      return user.lastlyUsedBusinessId
    }
  },
  // -----------------------------------------------------------------
  mutations: {
    updateUser: (state, user) => {
      localStorage.setItem("user", JSON.stringify(user))
    },
    updateLanguage: (state, language) => {
      localStorage.setItem("language", language)
    },
    removeUser: atate => {
      localStorage.removeItem("user")
    },
    updateLastlyUsedBusinessId: (state, bizId) => {
      state.lastlyUsedBusinessId = bizId
    }
  },
  // -----------------------------------------------------------------
  actions: {
    me: context => {
      var path = "/me"

      return apiUtils.get(path)
    },
    updateMe: (context, { name }) => {
      var path = "/me"
      var data = {
        name: name
      }

      return apiUtils.patch(path, data)
    },
    updateUser: (context, user) => {
      context.commit("updateUser", user)
    },
    updateLanguage: (context, language) => {
      context.commit("updateLanguage", language)
    },
    updateUsedBiz: (context, bizId) => {
      var path = "/me"
      var data = {
        lastlyUsedBusinessId: bizId
      }
      context.commit("updateLastlyUsedBusinessId", bizId)
      return apiUtils.patch(path, data)
    },
    updateLastlyUsedBusinessId: (context, bizId) => {
      context.commit("updateLastlyUsedBusinessId", bizId)
    },
    logout: context => {
      context.commit("removeUser")
    }
  }
}
